import { Form, Input, Button } from "antd";
import { SearchIcon } from "../icon";
import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useTableContext } from "@/common/contexts/Table.context";
import { useLocation } from "react-router";
import Typography from "../Typography/Typography";

export default function SearchBar() {
  const location = useLocation();
  const { onSearchQChange, filtersChanges } = useTableContext();
  const [isFocused, setIsFocused] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (filtersChanges === 0) {
      form.resetFields();
      return setIsFocused(false);
    }
  }, [location, filtersChanges]);

  const onSubmit = (values: { searchQ: string }) => {
    if (values.searchQ === undefined) return;
    setIsFocused(false);
    onSearchQChange(values.searchQ);
  };
  return (
    <Form
      form={form}
      onValuesChange={(changedValues) => {
        if ("searchQ" in changedValues) {
          setIsFocused(changedValues.searchQ !== "");
        }
      }}
      onFinish={onSubmit}
      name="search-form-input"
    >
      <Form.Item name="searchQ" className="mb-0">
        <div className="relative max-w-[394px] w-full flex items-center">
          <Typography type="span" absolute customStyles="z-10 left-4">
            <SearchIcon width="16" height="16" />
          </Typography>
          <Input
            className="rounded-full bg-gray-border pl-10 w-full py-2 border-none"
            placeholder="Search"
          />
          {isFocused && (
            <motion.div
              initial={{ opacity: 0, x: 10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.3 }}
            >
              <Button
                type="primary"
                shape="round"
                className="ml-2 min-h-[38px] text-base font-inter font-semibold"
                htmlType="submit"
              >
                Search
              </Button>
            </motion.div>
          )}
        </div>
      </Form.Item>
    </Form>
  );
}
